import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { useGetTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { TableCell } from './TableCell';
import { TableHeaderCell } from './TableHeaderCell';
const StyledTable = styled('table', ({ $dynamicColumnWidth }) => ({
    borderSpacing: 'unset',
    backgroundColor: staticColors.tableBackground,
    borderRadius: sizes.table.borderRadius,
    overflow: 'hidden',
    borderCollapse: 'separate',
    tableLayout: $dynamicColumnWidth ? 'auto' : 'fixed',
    width: '100%',
}));
export const Table = ({ testId, headerTestId, rows, columns, dynamicColumnWidth, emptyRow, emptyRowTestId, }) => {
    const getTestIdAttribute = useGetTestIdAttribute();
    const totalColumns = columns.length;
    const totalRows = rows.length;
    const tableHeaderCells = columns.map(({ key, title, textAlign, testId: columnTestId }, columnIndex) => {
        // The column testId is also used as a fallback for data cells (see below),
        // So the column header needs its own distinct testId to avoid both being
        // Selectable via the exact same test attribute.
        const columnHeaderTestId = columnTestId
            ? `${columnTestId}-header`
            : columnTestId;
        return (_jsx(TableHeaderCell, { title: title, textAlign: textAlign, columnIndex: columnIndex, totalColumns: totalColumns, testId: columnHeaderTestId }, key));
    });
    const tableRows = rows.flatMap((row, rowIndex) => {
        const rowItems = columns.map(({ key, textAlign, testId: columnTestId }, columnIndex) => {
            const cell = row.values[columnIndex];
            const cellTestId = cell?.testId ?? columnTestId;
            return (_jsx(TableCell, { testId: cellTestId, rowIndex: rowIndex, columnIndex: columnIndex, totalRows: totalRows, totalColumns: totalColumns, textAlign: textAlign, background: cell?.background, children: cell?.children }, key));
        });
        const rowTestIdAttribute = getTestIdAttribute(row.testId);
        return (_jsx("tr", { ...rowTestIdAttribute, children: rowItems }, row.key));
    });
    const maybeEmptyRow = emptyRow ? (_jsx("tr", { children: _jsx(TableCell, { testId: emptyRowTestId, rowIndex: 0, columnIndex: 0, totalRows: 1, totalColumns: 1, colSpan: columns.length, children: emptyRow }) }, 'empty')) : null;
    const shouldShowEmptyRow = !tableRows.length && !!maybeEmptyRow;
    const tableBodyRows = shouldShowEmptyRow ? maybeEmptyRow : tableRows;
    const headerTestIdRowAttribute = getTestIdAttribute(headerTestId);
    const tableTestIdAttribute = getTestIdAttribute(testId);
    return (_jsxs(StyledTable, { ...tableTestIdAttribute, $dynamicColumnWidth: dynamicColumnWidth, children: [_jsx("thead", { children: _jsx("tr", { ...headerTestIdRowAttribute, children: tableHeaderCells }) }), _jsx("tbody", { children: tableBodyRows })] }));
};
